import type { MaterialRequestItem } from "features/MaterialRequests/types/material-request.types";
import { materialRequestLineRemaining } from "features/MaterialRequests/utils/material-request.utils";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

/**
 * Maps MR lines to PO BOQ form rows using **remaining** requested quantity
 * (requested − net issued), skipping lines with nothing left to order.
 */
export function materialRequestItemsToPurchaseOrderBoqRows(
  items: MaterialRequestItem[] | null | undefined,
): QuotationItemFormRow[] {
  if (!items?.length) return [];
  const out: QuotationItemFormRow[] = [];
  for (const it of items) {
    const qty = materialRequestLineRemaining(it);
    if (qty <= 0) continue;
    const unit = String(it.unit ?? "PCS").trim() || "PCS";
    const rate = Number(it.rate);
    const safeRate = Number.isFinite(rate) && rate >= 0 ? rate : 0;
    const description =
      String(it.description ?? "").trim() ||
      String(it.remarks ?? "").trim() ||
      "Material";
    out.push({
      type: QuotationItemType.MATERIAL,
      description,
      quantity: qty,
      unit,
      rate: safeRate,
      materialRequestItemId: it.id ?? null,
    });
  }
  return out;
}
